<template>
    <div class="ef-bar">
        <div class="ef-search">
            <i class="fal fa-search ef-search-icon"></i>
            <input
                type="text"
                class="ef-search-input"
                :placeholder="$t('events.filters.search')"
                v-model="localSearch"
            />
        </div>

        <div class="ef-selects">
            <select class="ef-select" v-model="localType">
                <option value="">{{ $t('events.filters.all_types') }}</option>
                <option value="event">{{ $t('events.type.event') }}</option>
                <option value="project">{{ $t('events.type.project') }}</option>
            </select>

            <select class="ef-select" v-model="localStatus">
                <option value="">{{ $t('events.filters.all_statuses') }}</option>
                <option value="draft">{{ $t('events.status.draft') }}</option>
                <option value="published">{{ $t('events.status.published') }}</option>
                <option value="cancelled">{{ $t('events.status.cancelled') }}</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EventsFilters',
    props: {
        value: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            localSearch: this.value.search || '',
            localType: this.value.type || '',
            localStatus: this.value.status || ''
        }
    },
    watch: {
        localSearch(v) { this.emit() },
        localType(v)   { this.emit() },
        localStatus(v) { this.emit() }
    },
    methods: {
        emit() {
            this.$emit('change', {
                search: this.localSearch,
                type:   this.localType,
                status: this.localStatus
            })
        }
    }
}
</script>

<style scoped>
.ef-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 14px 20px;
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    margin-bottom: var(--v2-space-4);
}

.ef-search {
    position: relative;
    flex: 1;
    min-width: 0;
}

.ef-search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--v2-text-4);
    font-size: 0.85rem;
    pointer-events: none;
}

.ef-search-input {
    display: block;
    width: 100%;
    padding: 8px 12px 8px 34px;
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-md);
    background: var(--v2-surface-1);
    color: var(--v2-text-1);
    font-size: 0.875rem;
    outline: none;
    transition: border-color 0.15s;
    box-sizing: border-box;
}

.ef-search-input:focus {
    border-color: var(--v2-primary);
}

.ef-selects {
    display: flex;
    gap: 12px;
    width: 40%;
    flex-shrink: 0;
}

.ef-select {
    flex: 1;
    min-width: 0;
    height: 36px;
    padding: 0 8px;
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-md);
    background: var(--v2-surface-1);
    color: var(--v2-text-2);
    font-size: 0.875rem;
    cursor: pointer;
    box-sizing: border-box;
}

.ef-select:focus {
    outline: none;
    border-color: var(--v2-primary);
}

@media (max-width: 640px) {
    .ef-bar {
        flex-direction: column;
    }

    .ef-selects {
        width: 100%;
    }
}
</style>
